export default {
    dekiloknaller: {
        label: "De Kiloknaller",
        slug: "dekiloknaller",
        location: "Gush Etzion"
    },
    destandvastige: {
        label: "De Standvastige",
        slug: "destandvastige",
        location: "Jeruzalem"
    },
    dedemonstrant: {
        label: "De Demonstrant",
        slug: "dedemonstrant",
        location: "ramallah"
    },
    devrienden: {
        label: "De Vrienden",
        slug: "devrienden",
        location: "jenin"
    },
    depuber: {
        label: "De Puber",
        slug: "depuber",
        location: "Kiryat Arba"
    },
    deheilige: {
        label: "De Heilige",
        slug: "deheilige",
        location: "bethlehem"
    },
    depionier: {
        label: "De Pionier",
        slug: "depionier",
        location: "amona"
    },
    nazareth: "nazareth",
    golan: "golan",
    libanon: "libanon",
    gaza: "gaza",
    israel: "Israël",
    westelijke: "Westelijke",
    jordaanoever: "Jordaanoever",
    jordanie: "jordanië",
    egypte: "egypte",
    telaviv: "tel aviv",
    jeruzalem: "Jeruzalem",
    beersjeva: "beër sjeva",
    route60: "route 60",
    areaa: "areaa",
    areab: "areab",
    areac: "areac",
    jenin: "Jenin",
    hebron: "hebron",
    ramallah: "ramallah"
}



// WEBPACK FOOTER //
// ./src/data/nl/maps.js